<template>
  <form v-on:submit="save">
    <div class="card card-info" v-show="grid !== 'hide'">
      <div class="card-header with-border">
        <h3 class="card-title">Marking Criteria</h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class=" form-horizontal" style="padding-left: 2%; padding-right: 2%; padding-bottom: 2%; padding-top: 1%">
        <div class="row">
          <div class="col-md-4">
            <label>Semester</label>
            <select class="form-control" v-model="semester" v-on:change="loadteacher()">
              <option v-bind:value="0" disabled="disabled">--Select Semester--</option>
              <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
            </select>
          </div>

          <div class="col-md-4">
            <label>Teacher</label>
            <select class="form-control" v-model="teacher" v-on:change="loadcourse()">
              <option v-bind:value="-1" disabled="disabled">--Select Employee--</option>
              <option v-bind:value="0">All</option>
              <option v-for="item in teachers" v-bind:value="item.EmployeeRegistrationID">
                Code:{{item.EmployeeCode}}, Name:{{item.EmployeeName}}
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label>Course</label>
            <select class="form-control" v-model="course" v-on:change="loadproperty()">
              <option value="0" selected="selected" disabled="disabled">--Select Course--</option>
              <option v-for="item in courses" v-bind:value="item.CourseID"> {{item.CourseName}} ({{item.Section}}) ({{item.Type}})</option>
            </select>
          </div>
        </div>
          <div class="card" v-show="semester != 0 && teacher != -1 && course != 0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered" style="margin-top:10px">
                      <thead class="bg-info">
                        <tr>
                          <th style="width: 8%; text-align: center">Sr. #</th>
                          <th style="width: 40%">Method</th>
                          <th style="width: 30%">Term</th>
                          <th style="width: 12%; text-align: center;">Weightage (%)</th>
                          <th style="width: 10%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item,index) in child">
                          <td style="vertical-align: middle; text-align: center">
                            {{index + 1}}
                          </td>
                          <td>
                            <select v-bind:disabled="item.Post" class="form-control" v-model="item.PropertyID" id="ddlProp" v-on:change="checkDuplication(index, 'prop')">
                              <option :value="0" disabled="disabled">--Select Method--</option>
                              <option v-for="item in properties" :value="item.PropertyID">{{item.Name}}</option>
                            </select>
                          </td>
                          <td>
                            <select v-bind:disabled="item.Post" class="form-control" v-model="item.Term" v-on:change="checkDuplication(index, 'term')">
                              <option :value="0" disabled="disabled">--Select Term--</option>
                              <option :value="1">Mid Term</option>
                              <option :value="2">Final Term</option>
                              <option :value="3">Lab</option>
                            </select>
                          </td>

                          <td style="text-align: center;">
                            <input v-bind:disabled="item.Post" class="form-control" v-mask="'###'" v-on:change="calSum(index)" v-model="item.Weightage" />
                          </td>

                          <td style="text-align: center;">
                            <button v-if="item.Post" style="border: none; background-color: transparent"><i class="fa fa-lock fa-2x"></i></button>
                            <button v-if="!item.Post" v-on:click="remove(index)" type="button" style="background-color: transparent; border: none; font-size: 17px"><i class="fa fa-2x fa-trash"></i></button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="3" style="text-align:center "> <label>Allowed Weigtage: {{allowed}}</label> </td>
                          <td colspan="2" style="text-align:center "><label>Total: {{grandtotal}}</label></td>
                        </tr>
                        <tr v-if="grandtotal < 100 && post != 2">
                          <td colspan="5">
                            <button class="btn btn-default" type="button" v-on:click="addNew()" style="width: 100%"><i class="fa fa-plus" style="margin-right: 2px;"></i>Add New</button>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

      </div>

      <hr />
      <!--Button -->
      <div class="card-footer">
        <button class="btn btn-success float-right" style="width: 100px" v-if="update !== 'true'" type="submit">Save</button>
        <button type="button" class="btn btn-primary float-right" style="width: 100px" v-if="update === 'true'" v-on:click="updatemarkingcriteria()">Update</button>
        <button class="btn btn-danger" style="width: 100px" type="button" v-on:click="cancel()">Cancel</button>
      </div>
    </div>

    <div class="card card-info" v-show="grid === 'hide'">
      <div class="card-header">
        <h3 class="card-title" style="width: 100%">
          <button v-on:click="changestate('show')" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
        </h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class=" card-body" >
      <div class="row">
        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead class="bg-info">
              <tr>
                <th style="width:10%">sr #</th>
                <th style="width:30%">Teacher name</th>
                <th style="width:25%">Subject name</th>
                <th style="width:25%">Section</th>
                <th style="width:10%; text-align:center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, ind) in markingcriteria">
                <td>{{ind+1}}</td>
                <td>{{item.EmpName}}</td>
                <td>{{item.SubjectName}}</td>
                <td>{{item.SectionName}}</td>
                <td>
                  <button type="button" class="btn" v-on:click="edit(item.TeacherCourseAllotmentID), changestate('show')"><i class="fa fa-2x fa-edit"></i></button>
                  <button type="button" class="btn" style="background-color:transparent; border:none; color:green" v-on:click="loadmodal(item.TeacherCourseAllotmentID)"><i class="fa fa-eye fa-2x"></i></button>
                </td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>
      </div>
    </div>
            <div id="modal-xl" class="modal fade" role="dialog"  >
              <div class="modal-dialog modal-xl" style="width: auto !important">
                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title">Criteria</h4>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <table class="table table-sm table-bordered">
                          <thead class="bg-info">
                            <tr>
                              <th>Sr. no</th>
                              <th>Property Name</th>
                              <th>Term</th>
                              <th>Weightage</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, ind) in viewdata">
                              <td>{{ind+1}}</td>
                              <td>{{item.PropertyName}}</td>
                              <td>
                                <span v-show="item.Term == 1">Mid Term</span>
                                <span v-show="item.Term == 2">Final Term</span>
                                <span v-show="item.Term == 3">Lab</span>
                              </td>
                              <td align="right">{{item.Weightage}}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="3" style="text-align:center">Total</td>
                              <td align="right">{{total}}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>  
  </form>
 
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        child: [],
        teachers: [],
        semesters: [],
        courses: [],
        properties: [],
        allowed: 0,
        viewdata: [],
        data: { propertyid: 0, term: 0, weightage: 0 },
        grandtotal: 0,
        ind: -1,
        post: 0,
        semester: 0,
        teacher: -1,
        course: 0,
        total: 0,
        markingcriteria: [],
        criteriaID: 0,
        grid: 'hide',
        update: 'false',
      }
    },
    created: function () {
      this.loadsemester();
      this.loadmarkingcriteria();
    },

    methods: {
      changestate: function (state) {
        this.grid = state;
      },

      loadsemester: function () {
        var vm = this;
        axios.post('/api/ExamApi/loadsemester')
          .then(function (response) {
            vm.semesters = response.data.lst;
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadteacher: function () {
        startReq();
        var vm = this;
        axios.post('/api/ExamApi/loadteacher?ID=' + vm.semester)
          .then(function (response) {
            vm.teachers = response.data.lst;
            console.log(response);
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadcourse: function () {
        startReq();
        var vm = this;
        axios.post('/api/ExamApi/loadcourse?sem=' + vm.semester + '&tech=' + vm.teacher)
          .then(function (response) {
            vm.courses = response.data.lst;
            console.log(response);
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadproperty: function () {
        startReq();
        this.allowed = this.courses.find(u => u.CourseID == this.course).TotalMarks;
        var vm = this;
        axios.post('/api/ExamApi/loadproperties') //typ: vm.courses.find(u => u.CourseID).Type
          .then(function (response) {
            vm.properties = response.data.lst;
            console.log(response);
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      clearModal() {
        this.data = { propertyid: 0, term: 0, weightage: 0 };
      },

      //Modal
      showPopup() {
        this.ind = -1;
        $('#mdloutline').modal('show');
        this.clearModal();
      },

      loadmodal(courseallotID) {
        startReq();
        var vm = this;
        axios.post('/api/ExamApi/editmarkingcriteria?ID=' + courseallotID)
          .then(function (response) {
            vm.viewdata = response.data.lst;
            vm.total = 0;
            for (var item in vm.viewdata) {
              vm.total += vm.viewdata[item].Weightage;
            }
            console.log(response);
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
        $('#modal-xl').modal('show');
      },

      remove() {
        this.sum = this.sum - Number(this.child[this.ind].Weightage);
        this.child.splice(this.ind, 1);
        this.ind = -1;
        this.calSum();
        $('#mdloutline').modal('hide');
      },

      addNew() {
        this.child.push({ PropertyID: 0, Term: 0, Weightage: 0 });
      },

      checkDuplication(ind, val) {
        var ch = this.child[ind];
        for (var i = 0; i < this.child.length; i++) {
          if (this.child[i].PropertyID == ch.PropertyID && this.child[i].Term == ch.Term && i != ind) {
            toastr.error("Already Exist", "Error!");
            if (val == 'prop')
              this.child[ind].PropertyID = 0;
            else
              this.child[ind].Term = 0;
          }
        }
      },

      remove(index) {
        this.child.splice(index, 1);
        this.calSum(0);
      },

      cancel() {
        window.location.reload();
      },

      calSum() {
        this.grandtotal = 0;
        this.grandtotal = Number(this.data.weightage);
        for (var item in this.child) {
          this.grandtotal += Number(this.child[item].Weightage);
        }
        if (this.grandtotal > this.allowed) {
          toastr.error("Total Allowed Weightage is " + this.allowed, "Error!");
          this.grandtotal = this.grandtotal - Number(this.child[item].weightage);
          this.child[ind].Weightage = 0;
          return false;
        }

        else {
          return true;
        }
      },

      save(e) {
        e.preventDefault();
        if (this.grandtotal != this.allowed) {
          toastr.error("Total weightage must be equal to allowed weightage");
          return;
        }
        startReq();
        var vm = this;
        axios.post('/api/ExamApi/savemarkingcriteria?ID=' + vm.courses.find(u => u.CourseID == vm.course).TeacherCourseAllotmentID , {
          obj: vm.child
        })
          .then(function (response) {
            console.log(response);
            endReq();
            if (response.data == "Success") {
              toastr.success("Data is Save", "Success");
              setTimeout(vm.cancel, 1000);
            }
            else {
              toastr.error("Criteria Already Defined", "Error!");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadmarkingcriteria: function () {
        startReq();
        var vm = this;
        axios.post('/api/ExamApi/loadmarkingcriteria')
          .then(function (response) {
            vm.markingcriteria = response.data.lst;
            console.log(response);
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      edit: function (TeacherCourseAllotmentID) {
        startReq();
        var vm = this;
        axios.post('/api/ExamApi/editmarkingcriteria?ID=' + TeacherCourseAllotmentID)
          .then(function (response) {
            vm.child = response.data.lst;
            vm.criteriaID = vm.child[0].MarkingCriteriaID;
            vm.semester = vm.child[0].ActiveSemesterID;
            axios.post('/api/ExamApi/loadteacher?ID=' + vm.semester)
              .then(function (r1) {
                vm.teachers = r1.data.lst;
                console.log(response);

                vm.teacher = vm.child[0].EmployeeRegistrationID;
                axios.post('/api/ExamApi/loadcourse?sem=' + vm.semester + '&tech=' + vm.child[0].EmployeeRegistrationID)
                  .then(function (r2) {
                    vm.courses = r2.data.lst;
                    vm.course = vm.child[0].CourseID;
                    vm.allowed = vm.courses.find(u => u.CourseID == vm.course).TotalMarks;;
                    console.log(response);
                    axios.post('/api/ExamApi/loadproperties') //typ: vm.courses.find(u => u.CourseID).Type
                      .then(function (r3) {
                        vm.properties = r3.data.lst;
                        for (i = 0; i <= vm.child.lenght; i++) {
                          vm.child[i].find(u => u.PropertyID == data.PropertyID).Weightage = data[i].Weightage;
                          vm.child[i].find(u => u.PropertyID == data.PropertyID).Term = data[i].Term;
                        }
                        vm.calSum();
                      })
                      .catch(function (error) {
                        console.log(error);
                      });
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              })
              .catch(function (error) {
                console.log(error);
              });
            vm.update = 'true';
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      updatemarkingcriteria: function () {
        if (this.grandtotal != this.allowed) {
          toastr.error("Total weightage must be equal to allowed weightage");
          return;
        }
        var vm = this;
        axios.post('/api/ExamApi/updatedataaaa?ID=' + vm.courses.find(u => u.CourseID).TeacherCourseAllotmentID + '&CritariaID=' + vm.criteriaID, {
          obj: vm.child
        })
          .then(function (response) {
            if (response.data == "Success") {
              toastr.success("Data is Update", "Success");
              setTimeout(myFunction, 1000);
            }
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
      }

    }
  })
</script>



// WEBPACK FOOTER //
// src/components/exam/markingCriteria.vue